import useLabels from "hooks/useLabels";

type AskPaperEmptyThreadProps = {
  onExampleMessageClicked: (message: string) => void;
};

function AskPaperEmptyThread({
  onExampleMessageClicked,
}: AskPaperEmptyThreadProps) {
  const [askPaperLabels] = useLabels("ask-paper");

  return (
    <div className="flex flex-col h-full">
      <div className="flex items-center justify-center flex-1">
        <span className="text-center w-60 text-fg-muted base-normal">
          {askPaperLabels["empty-prompt"]}
        </span>
      </div>
      <div className="flex flex-col gap-2">
        {(askPaperLabels["examples"] as string[]).map((example, index) => (
          <button
            key={index}
            onClick={() => onExampleMessageClicked(example)}
            className="text-left inline-flex justify-center items-center relative whitespace-nowrap align-middle leading-[1.2] gap-2 py-2 px-4 base-normal sm-md bg-accent-bg-subtle hover:bg-accent-bg-muted rounded-br-sm rounded-xl w-full overflow-x-hidden"
          >
            <span className="flex-1">{example}</span>
            <i className="text-xl icon-arrow-right" />
          </button>
        ))}
      </div>
    </div>
  );
}

export default AskPaperEmptyThread;
